// extracted by mini-css-extract-plugin
module.exports = {"Poll":"Poll_Poll__3UABI","Title":"Poll_Title__2UhCr"};